import { atom } from 'recoil';
import { currentOrganisationType } from '../../types';

export const currentOrganisationAtom = atom<currentOrganisationType>({
  key: 'currentOrganisation',
  default: { isSelected: false, organisationId: '', profileId: '' },
});
